import { BaseWidgetDataProvider } from './BaseWidgetDataProvider';
import { BaseWebComponentDataProviderFactory } from '../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_NIRVANA } from '../webcomponents.constants';
import { GetWidgetDataRequest } from '../types/widget/types';
import { RequestOptions } from '@nirvana/shared/websocket-client';
import { Observable } from 'rxjs';

export class BaseWidgetDataProviderFactory<T> extends BaseWebComponentDataProviderFactory {
  constructor(dataFetchMethod: (request: GetWidgetDataRequest, options: RequestOptions) => Observable<T>) {
    super();
    this.map.set(API_TYPE_NIRVANA, BaseWidgetDataProvider.bind(null, dataFetchMethod));
  }
}
